module.exports = __webpack_public_path__ + "static/img/bg.73d474d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/bg.png
// module id = HumN
// module chunks = 1